import React from "react";
import PropTypes from "prop-types";
import { properCase } from "LIB/formatters/text";
import { EditButton } from "MODULES/shared/components";
import ShippingAddress from "MODULES/Orders/shared/ShippingAddress";
import Authorized from "MODULES/shared/components/Authorized";
import {
  ROLES,
  WAREHOUSE,
  WAREHOUSE_LOGISTICS_DIRECTOR
} from "MODULES/users/constants";
import { LINE_ITEMS, RETURN_TO_TYPE } from "APP_ROOT/constants";
import EditShipping from "../Edit/EditShipping";

const returnToWarning = (
  <div className="alert alert-danger">
    NOTE: There is an Open Sales Order applied to at least one item from this
    Repair Order.
  </div>
);

export default class ShippingDetails extends React.Component {
  state = {
    editShippingModalOpen: false
  };

  openShippingModal = () => {
    this.setState({ editShippingModalOpen: true });
  };

  closeShippingModal = () => this.setState({ editShippingModalOpen: false });
  render() {
    const { children, record, shippingType } = this.props;
    const { editShippingModalOpen } = this.state;
    const cancelled = record.get("cancelled");
    const hasOpenSalesOrders =
      shippingType === "return_to" &&
      record
        .get("line_items", [])
        .filter(
          l =>
            l.getIn(["inventory", "most_recent_sales_order"]) &&
            !l.getIn(["inventory", "most_recent_sales_order", "shipped"])
        ).size > 0;

    const returnToDiscrepancy =
      !record.get(LINE_ITEMS).isEmpty() &&
      !record
        .get(LINE_ITEMS)
        .every(i => i.get(RETURN_TO_TYPE) === record.get(RETURN_TO_TYPE));

    return (
      <div>
        <h2>
          {properCase(shippingType)}
          <Authorized
            roles={ROLES.filter(r => r !== WAREHOUSE)}
            subroles={[WAREHOUSE_LOGISTICS_DIRECTOR]}
          >
            {!cancelled && <EditButton handleClick={this.openShippingModal} />}
            <EditShipping
              record={record}
              open={editShippingModalOpen}
              close={this.closeShippingModal}
              shippingType={shippingType}
              required={false}
              returnToDiscrepancy={returnToDiscrepancy}
            />
          </Authorized>
        </h2>
        <ShippingAddress shippingType={shippingType} record={record} />
        {children}
        {hasOpenSalesOrders && returnToWarning}
      </div>
    );
  }
}

ShippingDetails.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  record: PropTypes.instanceOf(Object),
  shippingType: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/ShippingDetails.jsx